const translation = {
  PageSize: 'Формат',
  PageOrientation: 'Ориентация',
  Format: 'Разширение',
  DPI: 'Резолюция',
  Generate: 'Генерирай',
};

export default translation;
